<template>
    <v-dialog v-model="show" width="1200" @click:outside="onClose">
        <v-card style="min-height: 600px">
            <v-card-title primary-title class="headline grey lighten-2 pa-0">
                <v-layout row justify-space-between align-center>
                    <div class="ml-3">{{$t('detailStatistic') | capitalizeAll}}</div>
                    <v-btn flat icon @click="close">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-layout>
            </v-card-title>
            <v-card-text v-if="user">
                <v-layout row justify-space-between class="mb-3">
                    <div class="mr-5">
                        <table>
                            <tr>
                                <td>{{$t('name') | capitalize}}</td>
                                <td>{{user.name}}</td>
                            </tr>
                            <tr>
                                <td>{{$t('email') | capitalize}}</td>
                                <td>{{user.email}}</td>
                            </tr>
                            <tr>
                                <td>{{$t('phone') | capitalize}}</td>
                                <td>{{user.phone}}</td>
                            </tr>
                        </table>
                    </div>
                    <div>
                        <table>
                            <tr>
                                <td>{{$t('prepaidProject') | capitalize}}</td>
                                <td>{{user.project_prepaid_count | formatNumber}}</td>
                            </tr>
                            <tr>
                                <td>{{$t('postpaidProject') | capitalize}}</td>
                                <td>{{user.project_postpaid_count | formatNumber}}</td>
                            </tr>
                            <tr>
                                <td>{{$t('createdTime') | capitalize}}</td>
                                <td>{{user.created_time | formatDateTime}}</td>
                            </tr>
                        </table>
                    </div>
                    <div>
                        <v-btn-toggle v-model="isChartView" mandatory>
                            <v-btn flat :value="true">{{$t('graph')}}</v-btn>
                            <v-btn flat :value="false">{{$t('table')}}</v-btn>
                        </v-btn-toggle>
                    </div>
                </v-layout>
                <div>
                    <BarChart v-if="isChartView" ref="BarChart"></BarChart>
                    <SimpleDataTable v-else :items="data" :headers="headers"></SimpleDataTable>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import StatisticService from '@/services/statistic.service'
import SimpleDataTable from '@/modules/fptai/components/SimpleDataTable'
import moment from 'moment'
import VueChart from 'vue-chartjs'
import ApiService from '@/services/apis.service'

export default {
    name: 'UserStatisticDetail',
    components: { SimpleDataTable, BarChart: VueChart.Bar },
    data () {
        let timeRangeList = []
        let labels = []
        let today = moment().startOf('month').subtract(13, 'month')
        for (let i = 0; i <= 13; i++) {
            let timeStamp = today.add(1, 'month').valueOf()
            timeRangeList.push(timeStamp)
            labels.push(moment(timeStamp).format('YYYY-MM'))
        }
        labels.pop()

        return {
            show: false,
            user: null,
            data: [],
            timeRangeList,
            isChartView: true,
            labels
        }
    },
    computed: {
        headers () {
            const headers = [
                {
                    text: this.$t('name'),
                    value: 'name'
                }
            ]
            for (let i = this.timeRangeList.length - 6; i < this.timeRangeList.length - 1; i++) {
                headers.push({
                    text: moment(this.timeRangeList[i]).format('YYYY-MM'),
                    value: this.timeRangeList[i],
                    $value: item => item.request_count[i].count
                })
            }
            headers.push({
                text: this.$t('lastActive'),
                value: 'last_active',
                $value: item => this.$filters.formatDateTime(item.last_active)
            })
            for (let header of headers) {
                header.text = this.$filters.capitalize(header.text)
            }
            return headers
        }
    },
    methods: {
        open (user) {
            this.show = true
            this.user = user
            this.getStatistic()
        },
        close () {
            this.show = false
        },
        onClose () {
            this.user = null
            this.data = []
        },
        getStatistic () {
            this.$appService.showLoading()
            StatisticService.getUserStatistic(this.user.id, this.timeRangeList).then(
                result => {
                    this.data = result.data
                    this.drawChart()
                },
                this.$appService.handleRequestError('canNotLoadStatistic')
            ).finally(() => this.$appService.hideLoading())
        },
        drawChart () {
            if (this.$refs.BarChart) {
                let datasets = []
                for (let api of this.data) {
                    datasets.push({
                        type: 'line',
                        label: api.name,
                        backgroundColor: ApiService.getApiColor(api.api_code),
                        borderColor: ApiService.getApiColor(api.api_code),
                        borderWidth: 3,
                        data: api.request_count.map(item => item.count),
                        fill: false
                    })
                }
                this.$refs.BarChart.renderChart({
                    labels: this.labels,
                    datasets: datasets
                }, {
                    responsive: true,
                    maintainAspectRatio: false,
                    title: {
                        display: false
                    }
                })
            }
        }
    },
    watch: {
        show: {
            handler: function (show) {
                if (!show) {
                    // why we need timeout here? Because we need to wait for dialog to finish close effect fade out
                    setTimeout(() => {
                        this.onClose()
                    }, 500)
                }
            }
        },
        isChartView (val) {
            if (val) {
                this.$nextTick(this.drawChart)
            }
        }
    }
}
</script>

<style scoped>
    table tr td:first-child {
        padding-right: 15px;
        font-weight: bold;
    }
</style>
